<template>
  <div class="hidden sm:flex text-color whitespace-nowrap">
    {{ greeting }}
  </div>
</template>

<script lang="ts" setup>


import {computed} from "vue";
import {useAuthStore} from "@/stores/auth";
import {useStoreI18n} from "@/composables/useStoreI18n";

const authStore = useAuthStore();
const {t} = useStoreI18n();

const greeting = computed((): string =>  {
  const now = new Date();
  const hours = now.getHours();
  const name = authStore.account.fullName;
  if (hours < 12) {
    return t('good_morning') + ' ' + name + '!';
  } else if (hours < 18) {
    return t('hi') + ' ' + name + '!';
  } else {
    return t('good_evening') + ' ' + name + '!';
  }
});


</script>
